import "./locally-dealers.scss";
import { PageComponent } from "barba";

const reloadTimeoutMs = 1000;
const cookieConsentLevel = "necessary"; // No cookies yet

class LocallyDealers {
    constructor({ node }) {
        this.node = node;
        this.config = {
            companyId: node.dataset.locallyCompanyId,
            locale: node.dataset.locallyLocale,
            btnEndpointUrl: `${node.dataset.locallyBaseUrl}/stores/map.js`
        };

        this.log("LocallyDealers constructor");
        const onReady = () => {
            if (!this.ensureCookieConsent()) return;

            this.initLocally();
        };

        // Make sure cookieyes has loaded
        this.waitForReady(onReady);
    }

    waitForReady(callback) {
        if (document.readyState === "complete") {
            callback();
        } else {
            const interval = setInterval(() => {
                if (document.readyState === "complete") {
                    clearInterval(interval);
                    callback();
                }
            }, 100);
        }
    }

    ensureCookieConsent() {
        // CookieYes is only available on domain www.devinci.com
        if (!window.getCkyConsent) return true;

        const consent = window.getCkyConsent();

        if (!!consent?.categories[cookieConsentLevel]) return true;

        this.log("Locally dealer locator will not be activated because the user did not give consent for cookies.");
        this.node.style.display = "none";
        return false;
    }

    initLocally() {
        this.log("Locally dealer locator initializing...");

        ////////////////////////////////////////
        // Extracted from the locally dealer locator
        ////////////////////////////////////////
        const lcly_config = {
            company_name: "Devinci",
            company_id: `${this.config.companyId}`,
            lang: `${this.config.locale}`,
            inline: "1"
        };

        const lcly_query = Object.keys(lcly_config)
            .reduce(function (a, k) {
                a.push(
                    encodeURIComponent(k) +
                        "=" +
                        encodeURIComponent(
                            typeof lcly_config[k] === "object" && lcly_config[k] !== null
                                ? JSON.stringify(lcly_config[k])
                                : lcly_config[k]
                        )
                );
                return a;
            }, [])
            .join("&");

        const appendScript = (id, src) => {
            const s = document.createElement("script");
            s.id = id;
            s.async = true;
            s.src = src;
            this.node.appendChild(s);
        };

        setTimeout(() => {
            appendScript("lcly-script-0", `${this.config.btnEndpointUrl}?${lcly_query}`);
            this.log("Locally dealer locator initialized.");
        }, reloadTimeoutMs);
    }

    destroy() {
        this.log(`Locally dealer locator destroy`);
        delete this.node;
        delete this.config;
    }

    log(args) {
        if (process.env.NODE_ENV !== "development") return;

        console.log(args);
    }
}

new PageComponent("[data-locally-dealers]", LocallyDealers);
